import React from "react"
import Typography from "@mui/material/Typography"

export default function CountdownView({ value }: { value: number }) {
  if (value <= 0) return null

  return (
    <Typography
      sx={{
        position: "absolute",
        bottom: 0,
        left: 0,
        right: 0,
        m: "0 auto",
        fontSize: { xs: 120, sm: 180 },
        fontWeight: 500,
        color: "white",
        zIndex: 4,
        userSelect: "none",
        textShadow: "0px 2px 3px rgba(0,0,0,0.4)",
      }}
    >
      {value}
    </Typography>
  )
}
